$(document).on('submit', '[data-vcard-search]', function(event) {
  event.preventDefault();
  const q = $(this).find('input[name="q"]').val();
  $('[data-vcard-zips]').each((idx, vcard) => {
    if (!q || $(vcard).attr('data-vcard-zips').includes(q)) {
      $(vcard).removeClass('hide');
      $(vcard).parent().parent().removeClass('hide');
    } else {
      $(vcard).addClass('hide');
      $(vcard).parent().parent().addClass('hide');
    }
  });

  $('section').each((idx, section) => {
    if ($(section).find('[data-vcard-zips]').length) {
      if ($(section).find('[data-vcard-zips]:not(".hide")').length) {
        $(section).removeClass('hide');
      } else {
        $(section).addClass('hide');
      }
    }
  });

  if ($('[data-vcard-zips]:not(".hide")').length) {
    $('[data-vcard-empty]').addClass('hide');
  } else {
    $('[data-vcard-empty]').removeClass('hide');
  }
});
